<template>
	<div class="flex py-0.25 items-center space-x-2">
		<div v-if="!compact">
			<avatar v-if="extended || !currentUser.check()" :ava="user.ava"
					:online="user.is_online && currentUser.check()"
					:class="{'w-8 h-8': !compact, 'w-4 h-4': compact}"
			></avatar>

			<a v-else :href="user.url" class="block w-4 h-4 text-0">
				<avatar :ava="user.ava" :online="user.is_online" class="w-full h-full"></avatar>
			</a>
		</div>

		<div class="min-w-0">
			<div class="leading-none flex items-center space-x-2 min-w-0"
				 :class="{'font-medium': !compact, 'text-sm': compact}"
			>
				<div v-if="compact && !linked" class="min-w-0"
					 :class="{'text-gray-400': compact, 'text-black dark:text-white': !compact}"
				>
					{{ user.name }}
				</div>
				<a v-else :href="user.url"
				   class="block truncate min-w-0"
				   :class="{
					    'text-gray-400 hover:text-black dark:hover:text-white': compact,
					    'text-black dark:text-white': !compact,
                    }"
				>
					{{ user.name }}
				</a>

				<rating v-if="showRating" :rate="user.rate" class="text-sm shrink-0"></rating>

				<svg-icon
					v-if="user.is_verified"
					icon="check-circle-fill"
					class="w-3 h-3 text-blue-500 shrink-0"
				></svg-icon>
			</div>
			<div v-if="extended && user.description"
				 class="text-sm opacity-50 max-h-5 overflow-hidden max-w-full min-w-0">
				{{ user.description }}
			</div>
		</div>
	</div>
</template>
<script>
import User from "../../js/modules/User";
import Avatar from "./../partials/Avatar.vue";

export default {
	components: {Avatar},
	props: [
		'user',
		'compact',
		'extended',
		'showRating',
		'linked',
	],
	data() {
		return {
			currentUser: new User()
		};
	},
	methods: {
		inlineBg(ava) {
			return ava ? {backgroundImage: `url(${ava})`} : '';
		},
	}
}
</script>
